import Image from 'next/image';
import React from 'react';

const DEFAULT_IMAGE = '/td-home/images/landingpage/hero/iphone-mock-default.png';

interface IphoneImageProps {
  size: { width: number; height: number };
}

const IphoneImage: React.FC<IphoneImageProps> = ({ size }) => {
  return (
    <Image
      className="iphone"
      width={size.width}
      height={size.height}
      src={DEFAULT_IMAGE}
      alt="Leistungsübersicht von Abrechnung Direct dargestellt auf einem IPhone."
    />
  );
};

export default IphoneImage;
